import zango from 'zangodb'
import { mapGetters } from 'vuex'
import { getSolutionId } from '@/utils/auth'

export default {
  data() {
    return {
      solutionId: getSolutionId(),
      dbTable: {
        template: ['id', 'stamp', 'hash', 'file', 'sid'],
        log: ['uid', 'stamp', 'url', 'stateCode'],
        temporary: ['userId', 'templateId', 'sid', 'guid', 'remark', 'date', 'data'],
        tokenLog: ['sendTime', 'oldToken', 'newToken']
      },
      db: undefined
    }
  },
  computed: {
    ...mapGetters(['userId'])
  },
  mounted() {
    this.db = new zango.Db('client', 3, this.dbTable)
  },
  methods: {
    insertTemplateDB(data) {
      const template = this.db.collection('template')
      delete data.hit
      data.sid = this.solutionId
      template.insert(data).then(() => { }).catch(error => console.error(error))
    },
    findTemplateDB(id) {
      // this.db = new zango.Db('client', this.dbTable)
      const template = this.db.collection('template')
      return new Promise((resolve, reject) => {
        template.findOne({ sid: this.solutionId, id: { $eq: id } }).then(data => {
          resolve(data)
        })
      })
    },
    updateTemplateDB(id, data) {
      const template = this.db.collection('template')
      template.update({
        sid: this.solutionId,
        id: { $eq: id }
      }, {
        hash: data.hash,
        stamp: data.stamp,
        file: data.file,
        sid: this.solutionId
      }, (error) => {
        if (error) { throw error }
      })
    },
    // 暂存数据处理
    initTempoaryDB() {
      // this.db = new zango.Db('client', 2, this.dbTable)
      return this.db.collection('temporary')
    },
    findTemporarys(templateId, guid) {
      const temporary = this.initTempoaryDB()
      if (guid) {
        return new Promise((resolve, reject) => {
          temporary.findOne({
            userId: { $eq: this.userId },
            sid: { $eq: this.solutionId },
            templateId: { $eq: +templateId },
            guid: { $eq: guid }
          }, {
            date: 1,
            guid: 1,
            remark: 1
          }).then(data => {
            resolve(data)
          })
        })
      } else {
        return new Promise((resolve, reject) => {
          temporary.find({
            userId: { $eq: this.userId },
            sid: { $eq: this.solutionId },
            templateId: { $eq: +templateId }
          }, {
            date: 1,
            guid: 1,
            remark: 1
          }).toArray((error, data) => {
            resolve(data)
          })
        })
      }
    },
    getTemporaryData(templateId, guid) {
      const temporary = this.initTempoaryDB()
      return new Promise((resolve, reject) => {
        temporary.findOne({
          userId: { $eq: this.userId },
          sid: { $eq: this.solutionId },
          templateId: { $eq: +templateId },
          guid: { $eq: guid }
        }, {
          data: 1
        }).then(data => {
          resolve(data)
        })
      })
    },
    insertTemporaryData(data) {
      const temporary = this.initTempoaryDB()
      data.sid = this.solutionId
      data.guid = this.guid()
      data.userId = this.userId
      return new Promise((resolve, reject) => {
        temporary.insert(data).then(() => {
          resolve(data.guid)
        }).catch(error => console.error(error))
      })
    },
    updateTemporaryData(data) {
      const temporary = this.initTempoaryDB()
      data.userId = this.userId
      temporary.update({
        userId: { $eq: this.userId },
        sid: { $eq: this.solutionId },
        templateId: { $eq: +data.templateId },
        guid: { $eq: data.guid }
      }, data, (error) => {
        if (error) { throw error }
      })
    },
    deleteTemporaryData(templateId, guid) {
      const temporary = this.initTempoaryDB()
      return new Promise((resolve, reject) => {
        temporary.remove({
          userId: { $eq: this.userId },
          sid: { $eq: this.solutionId },
          templateId: { $eq: +templateId },
          guid: { $eq: guid }
        }).then(data => {
          resolve(data)
        })
      })
    },
    S4() {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
    },
    guid() {
      return (this.S4() + this.S4() + '-' + this.S4() + '-' + this.S4() + '-' + this.S4() + '-' + this.S4() + this.S4() + this.S4())
    }
  }
}
